import React, { useEffect, useState } from 'react';
import AvatarIcon from '@/assets/images/avatar_person.png';
import AvatarVIPIcon from '@/assets/images/avatar_vip.png';
import {
  GAHeaderClickToProfile,
  GAHeaderClickToHistory,
  GAHeaderClickToSetting,
  GAHeaderClickToUpgrade,
  GAHeaderClickLogout,
} from '@/ga/header';
import { useTranslation } from 'react-i18next';
import urlMap from '@/constants/url';
import '@/assets/header.scss';
import { Dropdown } from 'antd';
import Utils from '@/utils/utils';
import countryIcon from '@/constants/countryIcon';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as PersonalCenter } from '@/views/account/assets/icons/personal-center-white.svg';

import { ReactComponent as AllTools } from '@/views/account/assets/icons/all-tools-white.svg';

import { ReactComponent as FileIcon } from '@/views/account/assets/icons/file-icon-white.svg';

import { ReactComponent as Logout } from '@/views/account/assets/icons/logout.svg';

/**
 * 页面头部组件
 */
const Header = ({ profileObj, subscription, handleLogout, headerUrl }) => {
  let res = [];
  if (subscription != null) {
    res = [...subscription];
    res = res.filter((item) => {
      return item.status == 'Active';
    });
  }

  const navigate = useNavigate();

  const [languageStr, setLanguage] = useState(
    'en,de,es,fr,it,br,jp,kr,ar,nl,id,in,tr,ru,tw'
  );
  let lang = Utils.getLanguage();
  lang = lang === 'en' ? '' : lang;
  const hostname =
    // process.env.NODE_ENV === 'development'
    //   ? `${window.location.origin}${lang ? `/${lang}` : ''}`
    //   : lang === 'tr' || lang === 'ar'
    //   ? `${window.location.origin}/${lang}`
    //   : window.location.origin;
    process.env.NODE_ENV === 'development'
      ? `${window.location.origin}/tools${
          lang ? `/${lang}` : ''
        }/v2/account.html`
      : window.location.origin + '/tools/v2/account.html';
  console.log('hostname:', hostname, process.env.NODE_ENV);
  const { t } = useTranslation(['header', 'personalCenterSiderBar', 'common']);

  const urlHash = window.location.hash;
  console.log('urlHash:', urlHash);
  let urlSuffix = urlHash === '#/purchase' ? '?to=purchase' : ''; // 跳转登录/注册时的url后缀，如果是在purchase页面跳转，需要特殊处理
  console.log('urlSuffix:', urlSuffix);

  useEffect(() => {
    let filter = lang === '' ? 'en' : lang;
    let languageArr = languageStr.split(',');
    let newArr = languageArr.filter((item) => {
      return item !== filter;
    });
    setLanguage(() => {
      return newArr.join(',');
    });
  }, [lang]);

  const mobileAccountDropMenuRender = () => (
    <div className='mobile-menu menu' style={{ minWidth: 210 }}>
      <div className='user-info py-3'>
        <ul className='list-unstyled px-3 link-color-inherit mb-0'>
          <li className='fw-bolder mb-2'>
            <a
              href={`${hostname}#/personal-center/profile`}
              onClick={GAHeaderClickToProfile}
            >
              {profileObj.nickname
                ? profileObj.nickname
                : t('common:anonymous')}
            </a>
          </li>
          <li className='text-muted small'>
            <a
              href={`${hostname}#/personal-center/profile`}
              onClick={GAHeaderClickToProfile}
            >
              {profileObj.email}
            </a>
          </li>
        </ul>
      </div>
      <div className='px-3 py-3'>
        <ul className='list-unstyled link-color-inherit mb-0'>
          <li className='mb-2'>
            <a
              href={`${hostname}#/personal-center/history`}
              onClick={GAHeaderClickToHistory}
            >
              {t('personalCenterSiderBar:history')}
            </a>
          </li>
          <li className='mb-2'>
            <a
              href={`${hostname}#/personal-center/setting`}
              onClick={GAHeaderClickToSetting}
            >
              {t('personalCenterSiderBar:setting')}
            </a>
          </li>
          <li className='mb-0'>
            <a
              onClick={() => {
                handleLogout();
                GAHeaderClickLogout();
              }}
            >
              {t('common:logout')}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );

  return (
    <header className='header'>
      <nav className='navbar navbar-expand-lg navbar-dark bg-dark'>
        <div className='container-xl'>
          <a className='navbar-brand' href={urlMap.get('homepage')}>
            <svg
              width='118'
              height='32'
              xmlns='http://www.w3.org/2000/svg'
              xmlnsXlink='http://www.w3.org/1999/xlink'
            >
              <defs>
                <path
                  d='M4.304 26.053c.103 4.617 1.492 7.323 1.587 7.496v.01H3.564A3.558 3.558 0 010 30.01v-1.826l4.304-2.13zM59.508 9.58V14h3.068v2.99h-3.068v5.408c0 1.066.624 1.716 1.352 1.716.884 0 1.508-.702 1.508-1.118l1.43 2.652s-1.404 1.56-3.666 1.56c-2.236 0-3.952-1.092-3.952-3.796V16.99h-1.586V14h1.586V9.658l3.328-.078zm28.054 4.212c1.326 0 2.574.39 3.614 1.066V14h3.328v13h-3.328v-.858a6.624 6.624 0 01-3.614 1.066 6.708 6.708 0 01-6.708-6.708 6.708 6.708 0 016.708-6.708zM36.706 9.554v6.994h6.448V9.554h3.328V27h-3.328v-7.124h-6.448V27h-3.328V9.554h3.328zM52.722 14v13h-3.328V14h3.328zm19.5-4.446c4.238 0 6.76 2.6 6.76 5.798 0 3.224-2.522 5.824-6.76 5.824h-2.99V27h-3.328V9.554zM99.834 14l2.834 8.19 2.834-8.19h2.912l2.834 8.19 2.834-8.19h3.328l-4.498 13h-3.328l-2.626-8.372L104.332 27h-3.328l-4.498-13h3.328zM4.552 21.93c-.052.373-.096.739-.13 1.096l-.006.044c-.024.246-.043.487-.06.725L0 25.95v-1.768l4.552-2.253zM11.683 2c2.857.148 5.352 1.291 5.406 1.322 3.782 1.957 6.361 5.892 6.361 10.429 0 5.231-3.435 9.67-8.178 11.184-.064.02-.767.222-1.069.286-1.074-1.302-2.475-2.525-3.173-3.674a2.258 2.258 0 01-.386-1.262c0-.622.253-1.184.663-1.593.257-.256.574-.45.926-.557.005-.005.465-.139.708-.207.188-.06 1.225-.398 1.648-.602.594-.286 1.01-.661 1.01-1.16 0-.906-.901-.966-1.094-1.765-.109-.453-.356-1.02-.678-1.356-.485-.513-1.243-.863-2.11-.902v-2.026s-2.616.904-4.73 4.374L0 17.951V5.55C0 3.59 1.596 2 3.564 2h8.12zm75.983 14.912c-1.95 0-3.38 1.508-3.38 3.588s1.43 3.588 3.38 3.588 3.38-1.508 3.38-3.588-1.43-3.588-3.38-3.588zm-82.053.491a19.41 19.41 0 00-.608 2.07L0 21.95v-1.768l5.613-2.78zm66.609-4.729h-2.99v5.356h2.99c2.08 0 3.406-1.118 3.406-2.678 0-1.56-1.326-2.678-3.406-2.678zM51.058 8.046c.988 0 1.82.806 1.82 1.794 0 1.014-.832 1.82-1.82 1.82-.988 0-1.82-.806-1.82-1.82 0-.988.832-1.794 1.82-1.794z'
                  id='a'
                ></path>
              </defs>
              <use
                fill='#FFF'
                xlinkHref='#a'
                transform='translate(0 -2)'
                fillRule='evenodd'
              ></use>
            </svg>
          </a>
          <div className='d-flex d-lg-none align-items-center'>
            <div
              className='text-white d-inline-block'
              data-toggle='languageSwitch'
              data-language-list={languageStr}
              data-current-language='en'
              data-en-url='https://online.hitpaw.com/'
              data-de-url='https://online.hitpaw.de/'
              data-es-url='https://online.hitpaw.es/'
              data-fr-url='https://online.hitpaw.fr/'
              data-it-url='https://online.hitpaw.it/'
              data-br-url='https://online.hitpaw.com.br/'
              data-jp-url='https://online.hitpaw.jp/'
              data-kr-url='https://online.hitpaw.kr/'
              data-ar-url='https://ar.hitpaw.com/'
              data-id-url='https://online.hitpaw.id/'
              data-nl-url='https://online.hitpaw.nl/'
              data-in-url='https://online.hitpaw.in/'
              data-tr-url='https://tr.hitpaw.com/'
              data-ru-url='https://online.hitpaw.ru/'
              data-tw-url='https://online.hitpaw.tw/'
              data-bs-original-title=''
              title=''
            >
              {t('country')}
            </div>
            <div id='nav-account-mobile' className=' d-block d-lg-none ms-4 '>
              {profileObj ? (
                <li className='has-account dropdown position-relative py-0 d-flex align-items-center justify-content-center'>
                  <Dropdown
                    overlay={mobileAccountDropMenuRender}
                    getPopupContainer={() => document.querySelector('header')}
                    trigger={['click']}
                  >
                    {res.length > 0 && res[0]?.status == 'Active' ? (
                      <a className='vip px-0 py-0' href='javascript'>
                        <img
                          alt=''
                          src={AvatarVIPIcon}
                          className='me-1'
                          style={{ width: 40, height: 40 }}
                        />
                      </a>
                    ) : (
                      <span className='user px-0 py-0 d-flex align-items-center'>
                        <img
                          alt=''
                          src={AvatarIcon}
                          className='me-1'
                          style={{ width: 33, height: 33 }}
                        />
                        <a
                          href='javascript'
                          className=' d-inline-block text-white tiny'
                          style={{ padding: '0 !important' }}
                          onClick={(e) => {
                            e.stopPropagation();
                            window.location.replace(`${hostname}#/purchase`);
                          }}
                        >
                          {t('personalCenterHistory:upgradeBtn')}
                        </a>
                      </span>
                    )}
                  </Dropdown>
                </li>
              ) : (
                <li className='no-account d-flex'>
                  <a
                    className='nav-link login px-0 small text-white fw-bolder'
                    href={`${hostname}#/login`}
                  >
                    {t('common:login')}
                  </a>
                  <a
                    className='nav-link signUp px-0 d-none small text-white fw-bolder'
                    href={`${hostname}#/signUp`}
                  >
                    {t('common:signUp')}
                  </a>
                </li>
              )}
            </div>
          </div>
          <div
            className='collapse navbar-collapse'
            id='navbarSupportedContent-v1'
          >
            <ul className='navbar-nav ms-auto mb-2 mb-lg-0'>
              <li className='nav-item d-flex align-items-center'>
                <a className='nav-link'>
                  <div
                    className='text-white d-inline-block'
                    data-toggle='languageSwitch'
                    data-language-list={languageStr}
                    data-current-language='en'
                    data-en-url='https://online.hitpaw.com/'
                    data-de-url='https://online.hitpaw.de/'
                    data-es-url='https://online.hitpaw.es/'
                    data-fr-url='https://online.hitpaw.fr/'
                    data-it-url='https://online.hitpaw.it/'
                    data-br-url='https://online.hitpaw.com.br/'
                    data-jp-url='https://online.hitpaw.jp/'
                    data-kr-url='https://online.hitpaw.kr/'
                    data-ar-url='https://ar.hitpaw.com/'
                    data-id-url='https://online.hitpaw.id/'
                    data-nl-url='https://online.hitpaw.nl/'
                    data-in-url='https://online.hitpaw.in/'
                    data-tr-url='https://tr.hitpaw.com/'
                    data-ru-url='https://online.hitpaw.ru/'
                    data-tw-url='https://online.hitpaw.tw/'
                    data-bs-original-title=''
                    title=''
                  >
                    {t('country')}
                  </div>
                </a>
              </li>
              {!window.location.href.includes('profile') ? (
                <div className='proContainer'>
                  <div
                    class='pro-top'
                    onClick={() =>
                      (window.location.href = `${hostname}#/personal-center/profile?${headerUrl}`)
                    }
                  >
                    <span>{t('personalCenterHistory:upgradeBtn')}</span>
                  </div>
                </div>
              ) : (
                ''
              )}

              <div id='user-nav-desktop' className='d-none d-lg-block'>
                {profileObj ? (
                  <li className='nav-user nav-item drop-menu position-relative d-flex align-items-center justify-content-center'>
                    {res.length > 0 && res[0]?.status == 'Active' ? (
                      <a className='nav-link'>
                        <img
                          src={AvatarVIPIcon}
                          className='me-1'
                          style={{ width: 48, height: 48 }}
                        />
                      </a>
                    ) : (
                      <span className='nav-link'>
                        <img
                          src={AvatarIcon}
                          className='me-2'
                          style={{ width: 40, height: 40 }}
                        />
                        {/* <AvatarIcon className="me-2" /> */}
                        {/* <a
                          className='upgrade-link small'
                          style={{ fontWeight: 500 }}
                          href={`${hostname}#/purchase?${headerUrl}`}
                          onClick={GAHeaderClickToUpgrade}
                        >
                          {t('personalCenterHistory:upgradeBtn')}
                        </a> */}
                      </span>
                    )}
                    :
                    <div className='menu' style={{ minWidth: 230 }}>
                      <div className='user-info py-4'>
                        <ul className='list-unstyled px-4 link-color-inherit'>
                          <li
                            className='fw-bolder mb-1'
                            style={{
                              whiteSpace: 'nowrap',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              width: 160,
                            }}
                          >
                            <a
                              href={`${hostname}#/personal-center/profile?${headerUrl}`}
                              onClick={GAHeaderClickToProfile}
                            >
                              {profileObj.nickname
                                ? profileObj.nickname
                                : t('common:anonymous')}
                            </a>
                          </li>
                          <li className='text-muted small'>
                            <a
                              href={`${hostname}#/personal-center/profile?${headerUrl}`}
                              onClick={GAHeaderClickToProfile}
                            >
                              {profileObj.email}
                            </a>
                          </li>
                        </ul>
                      </div>
                      <div className='px-4 py-4'>
                        <ul className='list-unstyled link-color-inherit'>
                          <li className='hoverList'>
                            <AllTools className='headerIcon' />
                            <span
                              // href={`${hostname}#/personal-center/profile?${headerUrl}`}
                              onClick={() => {
                                GAHeaderClickToHistory();
                                window.location.href = `${hostname}#/personal-center/profile?${headerUrl}`;
                              }}
                            >
                              {t('upgradePersonal:Tools')}
                            </span>
                          </li>
                          <li className='hoverList'>
                            <FileIcon className='headerIcon' />
                            <span
                              // href={`${hostname}#/personal-center/history?${headerUrl}`}
                              onClick={() => {
                                GAHeaderClickToSetting();
                                window.location.href = `${hostname}#/personal-center/history?${headerUrl}`;
                              }}
                            >
                              {t('upgradePersonal:MyProjects')}
                            </span>
                          </li>
                          <li className='hoverList'>
                            <PersonalCenter className='headerIcon' />
                            <span
                              //href={`${hostname}#/personal-center/promotion?${headerUrl}`}
                              onClick={() => {
                                GAHeaderClickToSetting();
                                window.location.href = `${hostname}#/personal-center/promotion?${headerUrl}`;
                              }}
                            >
                              {t('upgradePersonal:MyAccount')}
                            </span>
                          </li>
                          <div className='divider'></div>
                          <li className='mb-0 hoverList'>
                            <Logout className='headerIcon' />
                            <span
                              onClick={() => {
                                handleLogout();
                                GAHeaderClickLogout();
                              }}
                            >
                              {t('common:logout')}
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                ) : (
                  <li className='nav-item'>
                    {localStorage.getItem('isSignin') ? (
                      <a
                        className='nav-link'
                        href={`${hostname}#/login${urlSuffix}`}
                      >
                        {t('common:login')}
                      </a>
                    ) : (
                      <a
                        className='nav-link'
                        href={`${hostname}#/signUp${urlSuffix}`}
                      >
                        {t('common:signUp')}
                      </a>
                    )}
                  </li>
                )}
              </div>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
